import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'',
    userInfoToken:'',
    userId:'',
    userInfo:''
  },
  mutations: {
    setUserId(state,id){
      state.userId=id
      sessionStorage.setItem('userId', id);
      // localStorage.setItem("userId", id);
    },
    removeUserId(state){
      state.userId=''
      sessionStorage.removeItem('userId')
      // localStorage.removeItem('userId')
    },
    setUserInfo(state,userInfo){
      state.userInfo=userInfo
      sessionStorage.setItem('userInfo', userInfo);
    },
    removeInfo(state){
      state.userInfo={}
      sessionStorage.removeItem('userInfo')
    },
    //获取业务 token
    setToken(state,token){
      state.token=token
      sessionStorage.setItem('token', token);
    },
    // 移除业务 token
    removeToken(state){
      state.token=''
      sessionStorage.removeItem('token')
    },
    //获取用户信息 token 
    setUserInfoToken(state,token){
      state.userInfoToken=token
      sessionStorage.setItem('userInfoToken', token);
      localStorage.setItem('userInfoToken', token);
    },
    //移除用户信息 token
    removeUserInfoToken(state){
      state.userInfoToken=''
      sessionStorage.removeItem('userInfoToken')
      localStorage.removeItem('userInfoToken')
    },

  },
  // 监听数据变化
  getters:{
    getStorage:state=>{
      if(!state.token){
        state.token =sessionStorage.getItem('token')
      }
      return state.token 
    },
    getUserInfoStorage:state=>{
      if(!state.userInfoToken){
        state.userInfoToken =sessionStorage.getItem('userInfoToken')
      }
      return state.userInfoToken 
    },
    getUserId(state){
      if(!state.userId){
        state.userId =sessionStorage.getItem('userId')
      }
      return state.userId 
    },
    getUserInfo(state){
      if(!state.userInfo){
        state.userInfo =sessionStorage.getItem('userInfo')
      }
      return JSON.parse(state.userInfo) 
    }
  },

  actions: {
  },
  modules: {
  }
})
